// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5459) return "static/chunks/5459-6672096775622031.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "688a7c8b538468e4" + ".js";
};